import { addDays, isAfter } from 'date-fns'

import { useSharedDates } from '@contexts/sharedDates'
import { useDate } from '@hooks/dates'

export function useResetPullAheadRange() {
  const { selectedDate } = useSharedDates()
  const { getWeekRange } = useDate()

  const { weekEnd: selectedWeekEnd } = getWeekRange(selectedDate)

  const { weekStart: pullAheadStartDate, weekEnd: pullAheadEndDate } =
    getWeekRange(new Date())

  const isPullAhead = isAfter(selectedDate, pullAheadEndDate)

  function getResetRange() {
    const minDate = addDays(selectedWeekEnd, 1)
    const maxDate = addDays(selectedWeekEnd, 22)

    return { minDate, maxDate }
  }

  function getPullAheadRange() {
    return { minDate: pullAheadStartDate, maxDate: pullAheadEndDate }
  }

  const { maxDate, minDate } = isPullAhead
    ? getPullAheadRange()
    : getResetRange()

  return { maxDate, minDate, isPullAhead }
}
